import mixpanelEvents from './mixpanel';

export default mixpanelEvents;
